import { render, staticRenderFns } from "./VesselMonitoringBay.vue?vue&type=template&id=72adab5b&scoped=true"
import script from "./VesselMonitoringBay.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringBay.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringBay.vue?vue&type=style&index=0&id=72adab5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72adab5b",
  null
  
)

export default component.exports